/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
    init: (app, Swiper, gsap, TomSelect, ModalVideo) => {
        /*
        |
        | Buttons animations hover
        |-----------
        */
        $(function () {
            $('.button')
                .on('mouseenter', function (e) {
                    var parentOffset = $(this).offset(),
                        relX = e.pageX - parentOffset.left,
                        relY = e.pageY - parentOffset.top;
                    gsap.set($(this).find('.anim'), { css: { top: relY, left: relX } })
                })
                .on('mouseout', function (e) {
                    var parentOffset = $(this).offset(),
                        relX = e.pageX - parentOffset.left,
                        relY = e.pageY - parentOffset.top;
                    gsap.set($(this).find('.anim'), { css: { top: relY, left: relX } })
                });
        });

        /*
        |
        | On anchor click scroll animation
        |-----------------
        */
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            // window.scrollTo({ top: $($.attr(this, 'href')).offset().top - 50, behavior: 'smooth' });
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 50,
            }, 1000);
        });

        /*
       |
       | Partners
       |-----------
       */
        const partners = new Swiper('.swiper.partners', {
            slidesPerView: 1.2,
            spaceBetween: 30,
            loop: false,
            centerInsufficientSlides: true,
            pagination: {
                el: '.swiper-pagination',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 1.8,
                },
                1024: {
                    slidesPerView: 2.8,
                },
                1200: {
                    slidesPerView: 4,
                },
                1600: {
                    slidesPerView: 5
                }
            }

        });



        /*
        |
        | Display iframe on click
        |-----------------
        */
        $(".iframe-wrapper").on('click', function (e) {
            $(this).addClass("active");
            $(this).find("iframe").attr("src", $(this).data("url"))
        });


        /*
        |
        | Chantiers
        |-----------------
        */
        new Swiper('.swiper.carousel', {
            slidesPerView: 1,
            spaceBetween: 30,
            // breakpoints: {
            //     1900: {
            //         slidesPerView: 1.2
            //     }
            // },
            navigation: {
                nextEl: '.carousel .navigation .next',
                prevEl: '.carousel .navigation .prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
        });


        if ($(".c-select").length) {

            const selects = document.querySelectorAll(".c-select");

            selects.forEach(select => {
                new TomSelect(select, {
                    allowEmptyOption: true,
                    hidePlaceholder: true,
                    maxItems: null,
                    plugins: ['checkbox_options', 'remove_button'],
                });
            });


        }

        new ModalVideo('.js-modal-btn');

    }
}
